var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "th",
    { class: _vm.col.class, style: _vm.col.style },
    [
      _vm._t("default"),
      _vm._v(" "),
      Array.isArray(_vm.col.sort)
        ? _c("SelectPicker", {
            attrs: {
              "data-width": "auto",
              "data-menu-width": "grow",
              "data-class": "btn-link",
              hideEmpty: "",
              menuHeading: _vm.$t("results.sort.sortBy"),
              title: _vm.$t("results.sort.sortBy"),
              placeholder: _vm.col.label,
              options: _vm.col.sort,
              disabled: _vm.disabled,
              value:
                _vm.sort?.replace(/^-/, "") ||
                null /* strip inverted sort value for display purposes */,
              showValues: false,
            },
            on: { change: _vm.changeSort },
          })
        : _vm.col.sort
        ? _c(
            "a",
            {
              class: ["sort", { disabled: _vm.disabled }],
              attrs: { role: "button", title: _vm.col.title },
              on: {
                click: function ($event) {
                  return _vm.changeSort(_vm.col.sort)
                },
              },
            },
            [
              _vm._v("\n\t\t" + _vm._s(_vm.col.label) + " "),
              _c("debug", [
                _c("b", [
                  _vm._v("[" + _vm._s(_vm.col.debugLabel || _vm.col.key) + "]"),
                ]),
              ]),
            ],
            1
          )
        : _c(
            "span",
            { attrs: { title: _vm.col.title } },
            [
              _vm._v(_vm._s(_vm.col.label) + " "),
              _c("debug", [
                _c("b", [
                  _vm._v("[" + _vm._s(_vm.col.debugLabel || _vm.col.key) + "]"),
                ]),
              ]),
            ],
            1
          ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }